import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/hospital/hospitalData.json";

export default function Hospital() {
  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Высокотехнологичная медицинская помощь
      </h1>

      <Accordion data={data} />
    </section>
  );
}
